<script lang="ts">
  import { _, time } from 'svelte-i18n';
  import Modal from './Bootstrap/Modal.svelte';
  import route from './Util/routes';
  import { dispatchExerciseChangeEvent, getRequest } from './Util/utils';
  import { format_timespan, format_elapsed, time as current_time } from './time';
  import { getContext, onMount } from 'svelte';
  import { addHours, format } from 'date-fns';
  import type { CalendarEventBody } from './Util/api';
  import type { Writable } from 'svelte/store';
  import { CreateCustomEventDispatchHandler } from "@/EventDispatchers";

  export let isActivityPicker: boolean = false;
  export let isCalendarCard : boolean = false;
  export let flexDirection = 'column';
  export let phoneView = false;
  export let halfView = false;
  export let showPlayButton: boolean = true;
  export let showScheduleButton: boolean = true;
  export let showClearButton: boolean = false;
  export let exerciseType = 'Workout';
  export let isSelectedWorkout: boolean = false;
  export let isReady: boolean = false;
  export let scheduleThisSession;
  export let playSessionNow;
  export let clearExercise;
  export let onScheduleCallback: (body: CalendarEventBody) => Promise<any>

  export let openPlayerOnPlay = true;
  export let details_page = false;
  export let is_premium = false;

  export let showScheduleModal;
  export let closeScheduleModal;
  export let start_date: string | Date = null;
  export let duration;
  export let isPlanned
  let _showScheduleModal;
  showScheduleModal = ()=>{
    // Initialize date/time before showing the modal.
    if (!workoutDate || !workoutTime) {
      // let date = addHours(new Date(), 1
      const date = new Date()
      workoutDate = format(date, 'yyyy-MM-dd')
      workoutTime = $time(date, {hour12: false, hour: '2-digit', minute: '2-digit' })

    }
    _showScheduleModal()
  }


  let isForecast:Writable<any> = getContext('training_plan_is_forecast');

  export let path;
  export let activityPath;

  export let disabled = false;

  let workoutDate, workoutTime

  let div;
  //@ts-ignore
  const jq = window.$;
  //@ts-ignore
  const Xert = window.Xert

  let eventDispatchHandler;
  let dispatchTrainingEvent
  let now = new Date();
  onMount(() => {
    [eventDispatchHandler, dispatchTrainingEvent] = CreateCustomEventDispatchHandler(div, ()=>{});
    jq('[data-toggle=tooltip]').tooltip({container: 'body'});//Tooltips used in bootstrap button groups must have this set
    jq('[data-toggle=tooltip]').tooltip();
  });

  let username = Xert._username;
  let chartURL = `/video?view=chart&user=${username}`;
  let gaugeURL = `/video?view=power&user=${username}`;

  let startDateObj = start_date ? new Date(start_date) : null;
  $: startDateObj = start_date ? new Date(start_date) : null;
  let endDateObj = (start_date && duration) ? new Date(startDateObj.getTime() + duration*1000) : null;
  $: endDateObj = (start_date && duration) ? new Date(startDateObj.getTime() + duration*1000) : null;

  $: dateNow = [now.getFullYear().toString(), (now.getMonth() + 1).toString().padStart(2, '0'), now.getDate().toString().padStart(2, '0')].join('-');
  $: timeNow = [now.getHours().toString().padStart(2, '0'), now.getMinutes().toString().padStart(2, '0')].join(':');

  // TODO: Does this work properly? timeNow and workoutTime are strings so it just does a lexical comparison, which is probably OK for hh:mm:ss?
  $: dateInvalid = (dateNow > workoutDate) || (dateNow == workoutDate && timeNow > workoutTime);

  $: dateUndefined = typeof(workoutDate) == 'undefined' || typeof(workoutTime) == 'undefined';

  // Tooltip text.
  $: title = disabled ? 'Premium Only' : null;

  let chartWindow = function(){
    window.open(chartURL, `_chart`, 'toolbar=0, menubar=0, location=0, width=1200,height=300');
  }
  let gaugeWindow = function(){
    window.open(gaugeURL, `_gauge`, 'toolbar=0, menubar=0, location=0, width=400px,height=400px');
  }

  function onScheduleButtonClick() {
    if(!$isForecast?.isForecastPlan){
        console.log('is not forecast!')
        scheduleThisSession();
        return;
    }
    startDateObj = startDateObj ?? new Date(Date.now())
    workoutDate = format(startDateObj, 'yyyy-MM-dd')
    workoutTime = $time(startDateObj, {hour12: false, hour: '2-digit', minute: '2-digit' })
    dateUndefined = false
    scheduleWorkout()
    // if (disabled) return;
    // scheduleThisSession();
  }

  async function scheduleWorkout() {
    if(disabled || dateInvalid || dateUndefined) return;
    const timestamp = workoutDate + 'T' + workoutTime + ':00'

    let body = {
      id: path,
      type: exerciseType.toLowerCase(),
      start_date: timestamp,
      end_date: timestamp,
      forUser: Xert._username,
      from_xata: 0,
      options: '',
    };

    await onScheduleCallback(body)

    closeScheduleModal();

    dispatchExerciseChangeEvent(div);
  }

   function tryPlayThisSession() {
    if (disabled) return;

    let promise = playSessionNow()?.catch(error=>{
      console.log(error);
      if (error.type == 'overlap') {
        let message;
        if (error.n < 2) {
          // TODO: use svelte-i18n to handle plurals. Also do the same in SessionJoinButton.
          message = 'You have an overlapping session scheduled. Leave that session and schedule this one?';
        } else {
          message = 'You have overlapping sessions scheduled. Leave these sessions and schedule this one?';
        }
        if(confirm(message)) {
          // Force join session, which clears conflicts.
          return playSessionNow(true);
        }
      } else {
        setTimeout(()=>alert(error.msg));
      }
      return Promise.reject(error.message);
    }).then(data=>{
      // Successfully scheduled session, open video player page.
      if(openPlayerOnPlay) window.open(route('RemotePlayerController@getVideoPlayer'), '_remote');
      dispatchExerciseChangeEvent(div);
      if( ($isForecast?.isForecastPlan) && !(data instanceof Error)) {
        onScheduleButtonClick()
      }
    });

    return promise ?? Promise.reject('Error???');
  }

  let myBoxSize:ResizeObserverSize[] = [{blockSize: 0, inlineSize: 0} as ResizeObserverSize];

  $:  useClearIcon = myBoxSize[0].inlineSize < 260; // 310px

  $: showSelectAndSave = !showPlayButton && !showClearButton && !showScheduleButton && (isCalendarCard || isActivityPicker);
  function selectAndSave() {
        dispatchTrainingEvent("selectAndSave", {});
  }
</script>

<Modal bind:show={_showScheduleModal} bind:close={closeScheduleModal}>
  <h4 slot="title" class="modal-title" id="myModalLabel">{'Schedule ' + exerciseType}</h4>
  <div class="schedule-modal-content">
    <span class="schedule-modal-element">
      <p>{exerciseType + ' Date'}</p>
      <input bind:value={workoutDate} type="date">
    </span>
    <span class="schedule-modal-element">
      <p>{exerciseType + ' Time'}</p>
      <input bind:value={workoutTime} type="time">
    </span>
  </div>
  {#if dateInvalid}
    <p style="color: red;">Please choose a time in the future</p>
  {/if}
  <svelte:fragment slot="footer">
    <button type="button" class="btn btn-default" class:disabled={dateInvalid || dateUndefined} on:click={scheduleWorkout}>Schedule</button>
  </svelte:fragment>
</Modal>

{#if isPlanned && startDateObj && startDateObj.getTime() > $current_time.getTime()}
<span class="text">
  <h3 class="timestamp" style={phoneView && "margin: 5px 0;"}>
    <a target="activity" href="/activities/{exerciseType == "Workout" ? activityPath : path}{exerciseType == "Workout" ? `?forUser=${Xert._username}` : ""}">
      {$_("sessions.card.starts")} {format_timespan(startDateObj, $current_time)}
    </a>
  </h3>
</span>
{:else if startDateObj && endDateObj && startDateObj.getTime() < $current_time.getTime() && endDateObj.getTime() > $current_time.getTime()}
<span class="text">
  <h3 class="timestamp" style={phoneView && "margin: 5px 0;"}>
    {$_("sessions.card.started")} {format_elapsed($current_time, endDateObj)}
  </h3>
</span>
{/if}

<div bind:this={div} bind:borderBoxSize={myBoxSize} class="buttons" style={(phoneView ? 'flex-grow: 1;' : '') + (!phoneView && halfView && !showSelectAndSave ? 'margin-left: 20px;' : '') + 'flex-direction: ' + flexDirection}>
  {#if is_premium && showPlayButton}
    {#if openPlayerOnPlay}
      <div class="btn-group">
        <button class="btn grouped-btn" style={phoneView && "flex-grow: 1;"} title="Open Player" on:click|preventDefault={!isReady ? tryPlayThisSession : () => {window.open('/video');}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.745117 1.41192C0.745178 1.29832 0.774263 1.18663 0.829613 1.08743C0.884963 0.988234 0.964742 0.904826 1.06138 0.84512C1.15802 0.785414 1.26831 0.751392 1.38179 0.746281C1.49527 0.74117 1.60817 0.76514 1.70978 0.815916L14.8858 7.40392C14.9964 7.45934 15.0894 7.54444 15.1543 7.6497C15.2193 7.75496 15.2537 7.87622 15.2537 7.99992C15.2537 8.12362 15.2193 8.24488 15.1543 8.35013C15.0894 8.45539 14.9964 8.54049 14.8858 8.59592L1.70978 15.1839C1.60817 15.2347 1.49527 15.2587 1.38179 15.2536C1.26831 15.2484 1.15802 15.2144 1.06138 15.1547C0.964742 15.095 0.884963 15.0116 0.829613 14.9124C0.774263 14.8132 0.745178 14.7015 0.745117 14.5879V1.41192Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {#if !isPlanned && !isReady}
            {$_('sessions.card.play_session')}
          {/if}
        </button>
        {#if isPlanned || isReady}
        <button class="btn grouped-btn" style={phoneView && "flex-grow: 1;"} title="Power Gauge" on:click={gaugeWindow}>
          <i class="fa-light fa-gauge fa-lg"></i>
        </button>
        <button class="btn grouped-btn" style={phoneView && "flex-grow: 1;"} title="Workout Chart" on:click={chartWindow}>
          <i class="fa-light fa-chart-simple fa-lg"></i>
        </button>
        {/if}
      </div>
    {:else}
      <button {disabled} class="btn play-btn styled-btn" style={phoneView && 'flex-grow: 1;'} data-toggle="tooltip" {title} class:showPlay={true} class:rightMargin={details_page} class:smallHeight={details_page} on:click={()=>tryPlayThisSession()}>
        <svg width="16" height="16" style="margin: 4px;" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.745117 1.41192C0.745178 1.29832 0.774263 1.18663 0.829613 1.08743C0.884963 0.988234 0.964742 0.904826 1.06138 0.84512C1.15802 0.785414 1.26831 0.751392 1.38179 0.746281C1.49527 0.74117 1.60817 0.76514 1.70978 0.815916L14.8858 7.40392C14.9964 7.45934 15.0894 7.54444 15.1543 7.6497C15.2193 7.75496 15.2537 7.87622 15.2537 7.99992C15.2537 8.12362 15.2193 8.24488 15.1543 8.35013C15.0894 8.45539 14.9964 8.54049 14.8858 8.59592L1.70978 15.1839C1.60817 15.2347 1.49527 15.2587 1.38179 15.2536C1.26831 15.2484 1.15802 15.2144 1.06138 15.1547C0.964742 15.095 0.884963 15.0116 0.829613 14.9124C0.774263 14.8132 0.745178 14.7015 0.745117 14.5879V1.41192Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p>{$_('sessions.card.play_session')}</p>
      </button>
    {/if}
  {/if}
  {#if showScheduleButton}
    <button {disabled} class="btn schedule-btn styled-btn" data-toggle="tooltip" {title} style={phoneView && 'flex-grow: 1;'} class:showSchedule={true} class:smallHeight={details_page} on:click={onScheduleButtonClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>
      <p>{$_('sessions.card.schedule_session')}</p>
    </button>
  {/if}
  {#if showClearButton}
    <button class="btn clear-btn styled-btn smaller-btn" style={phoneView && 'flex-grow: 1;'} class:clear={true} class:smallHeight={details_page} on:click={clearExercise}>
        {#if useClearIcon && is_premium && showPlayButton}
            <i class="fa-regular fa-xmark-large fa-lg"></i>
        {:else}
            <p>{$_('sessions.card.clear_workout')}</p>
        {/if}
    </button>
  {/if}

  {#if showSelectAndSave}
    <button class="btn play-btn styled-btn" on:click={selectAndSave} style={phoneView && 'flex-grow: 1;'} class:showSchedule={true}>
        Select {#if isCalendarCard} & Save {/if}
    </button>
  {/if}
</div>

<style lang="scss">

  .buttons {
    display: flex;
    align-items: center;
    margin: 0 -10px;
    max-width:100%;
  }

  .schedule-modal-content {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .schedule-modal-element {
      display: flex;
      flex-direction: column;
      width: 150px;
      margin: 0 5px !important;

      > p {
        text-align: left;
        margin: 0 2px !important;
      }
    }
  }

  input {
    border: 1px solid var(--color-xert-gray);
    border-radius: 3px !important;
    background-color: white;
    padding: 4px 8px;
    color: var(--color-xert-gray-text);
  }

  input:hover {
    border-color: var(--color-xert-blue);
  }

  button.styled-btn {
    @import './style/xert.scss';
  
    display: flex;
    gap: 10px;
    justify-content: center;
    width: var(--xert-button-width, 130px);
  
    background: var(--color-xert-teal);
    border-radius: 4px !important;
    margin: 10px;
  
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px !important;
  
    /* identical to box height */
    text-align: center;
    letter-spacing: 0.48px;

    position: relative;

    > p {
      margin: 0;
    }
  
    /* identical to box height */
    text-align: center;
    letter-spacing: 0.48px;
    transition: background 0.4s;
  
    color: #FFFFFF;

    &.showPlay {
      background: var(--color-xert-blue);

      &.rightMargin {
        margin-right: 16px;
      }

      &:hover {
        background: var(--color-xert-lime);
      }
    }
    &.showSchedule {
      background: var(--color-xert-blue);

      &:hover {
        background: var(--color-xert-lime);
      }
    }
    &.clear {
      background: white;
      border: 1px solid var(--color-xert-blue);
      color: var(--color-xert-blue);
    }

    &.clear:hover {
      background: var(--color-xert-blue) !important;
      color: white;
    }
    &.bigger-btn {
      width: var(--xert-button-width, 160px);
    }

    &.smaller-btn {
      width: var(--xert-button-width, 100px);
    }
  }

  .timestamp {
    font-weight: 500 !important;
    font-size: 22px !important;
    margin: 0;
  }

  .timestamp > a {
    color: #34495e;
  }

  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .grouped-btn {
    min-width: 56.5px;
    gap: 10px;
    width: auto;
    height: 38px;
    background: var(--color-xert-blue);
    display: flex;
    justify-content: center;
    margin: 10px 0px;
    color: #FFFFFF;
    text-align: center;
    align-items: center;
    flex-grow: 1;
    &:hover {
      background: var(--color-xert-lime);
    }
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  .btn-group {
    display: flex;
    max-width: var(--xert-button-width);
    width: 100%;
    flex-grow: 1;
    margin: 0px 10px;
  }

  .schedule-btn {
    overflow: visible !important;
  }
</style>